import React, { FunctionComponent } from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import { Moment } from 'moment';

import { TPenaltyWaiverTutorAmountData } from '../../../../../../../store/V2/PenaltyWaiverSlice';

interface PenaltyDataSummaryViewProps {
  startDate?: Moment | null;
  endDate?: Moment | null;
  tutorAmountData?: TPenaltyWaiverTutorAmountData;
}

const CustomAlertView = ({ content }: { content: string }) => {
  return (
    <Card
      elevation={0}
      sx={{ backgroundColor: '#2d8cff', borderRadius: '8px' }}
    >
      <CardContent style={{ padding: '8px' }}>
        <Typography
          fontSize="14px"
          fontWeight={600}
          color="#ffffff"
          textAlign="center"
        >
          {content}
        </Typography>
      </CardContent>
    </Card>
  );
};

const PenaltyDataSummaryView: FunctionComponent<PenaltyDataSummaryViewProps> = ({
  startDate,
  endDate,
  tutorAmountData,
}) => {
  const tutorPenaltyData =
    tutorAmountData && tutorAmountData.tutorPenaltyAmountData
      ? tutorAmountData.tutorPenaltyAmountData
      : undefined;

  let tutorPenaltySummaryText = 'Total Tutor Penalty Amount';

  if (startDate && endDate) {
    tutorPenaltySummaryText += ` (${startDate.format(
      'ddd MMM DD YYYY'
    )} to ${endDate.format('ddd MMM DD YYYY')})`;
  } else if (startDate && !endDate) {
    tutorPenaltySummaryText += ` (from ${startDate.format('ddd MMM DD YYYY')})`;
  } else if (endDate && !startDate) {
    tutorPenaltySummaryText += ` (upto ${endDate.format('ddd MMM DD YYYY')})`;
  }

  tutorPenaltySummaryText += ' - ';

  if (tutorPenaltyData) {
    const currencies = Object.keys(tutorPenaltyData || {});

    let amountData = '';

    currencies.forEach((currency) => {
      const amount = tutorPenaltyData[currency] || 0;

      amountData += ` / ${currency} ${parseFloat(
        amount.toFixed(2)
      ).toString()}`;
    });

    amountData = amountData.substring(2).trim();

    tutorPenaltySummaryText += `(${amountData})`;
  } else {
    tutorPenaltySummaryText += `(00)`;
  }

  return (
    <Stack gap="10px" sx={{ padding: '0 20px 20px 20px' }}>
      {tutorPenaltyData && Object.keys(tutorPenaltyData || {}).length ? (
        <CustomAlertView content={tutorPenaltySummaryText} />
      ) : null}
    </Stack>
  );
};

export default PenaltyDataSummaryView;
